import { apps, chains, client, isUserProcessLoading, stores, user, users } from 'core/selectors';
import { deleteUser, getClient, getUser, getUsers, revokeMfa } from 'core/slices/users';
import { connect } from 'react-redux';
import ClientsList from '../../../components/clients/ClientsList';

export default connect(
  state => ({
    users: users(state),
    user: user(state),
    isUserProcessLoading: isUserProcessLoading(state),
    chains: chains(state),
    stores: stores(state),
    apps: apps(state),
    client: client(state)
  }),
  { getUsers, getUser, deleteUser, getClient, revokeMfa },
)(ClientsList);
